import UserLandingPage from 'content/pages/UserLandingPage';
import { getSharedUserPageProps } from 'utils/pageProps/sharedUserPageProps';

export default UserLandingPage;

export const getServerSideProps = getSharedUserPageProps(false);
